import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import EGWB from "../../assets/images/EGWB-logo.svg";
import CustomButton from "../CustomButton/CustomButton";

const Footer = () => {
  return (
    <footer className="bg-gradient-theme py-49 footer overflow-hidden">
      <div className="container custom-container">
        <div className="footer-topbar bg-white py-10 py-sm-17 px-10 px-sm-20 px-md-29 mb-50 d-flex justify-content-between flex-wrap gap-3" data-aos="fade-up" data-aos-duration="1000">
          <div className="logo d-flex align-items-center">
            <LazyLoadImage
              src={EGWB}
              alt="EGWB Logo"
              effect="blur"
              width={"44"}
            />
            <div className="fw-semibold pNovaFamily ms-13">
              <span>EGWB</span>
            </div>
          </div>
          <form style={{maxWidth: "650px", width: "100%"}}>
            <div className="d-flex gap-2 flex-wrap flex-nowrap">
              <input
                type="text"
                placeholder="Your Email"
                className="form-control"
              />
              <CustomButton
                classes="btn btn-primary no-shadow h-auto py-11"
                label="Subscribe"
                type="button"
              />
            </div>
          </form>
        </div>
        <div className="footer-wrapper mx-auto d-flex justify-content-start justify-content-xl-between flex-wrap mb-10 mb-sm-20 mb-md-35 mb-lg-50">
          <div className="footer-column">
            <h5 className="ah-text-md mb-15 mb-md-20 fw-bold">Our Company</h5>
            <ul className="list-unstyled">
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Why Choose EGWB?
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Our Customers
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Newsroom Updates
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Join Our Team
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Compliance and Security
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Become a Partner
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Current Partners
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Partner Marketplace
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h5 className="ah-text-md mb-15 mb-md-20 fw-bold">Our Products</h5>
            <ul className="list-unstyled">
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Learning Management System (LMS)
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Learning Experience Platform (LXP)
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Training Academies
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  AI in Learning & Development
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Integrations Available
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Pricing Plans
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Start Your Free Trial
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h5 className="ah-text-md mb-15 mb-md-20 fw-bold">Use Cases and Trends</h5>
            <ul className="list-unstyled">
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Collaborative Learning
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Employee Onboarding
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Compliance Training
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Sales Enablement
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Frontline Staff Training
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Customer Training Programs
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Mobile Learning Solutions
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Hybrid Learning Approaches
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h5 className="ah-text-md mb-15 mb-md-20 fw-bold">
              Resources and Community
            </h5>
            <ul className="list-unstyled">
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Ebooks, Guides, and Tools
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  The L&D Collective
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  L&D Masterclass Sessions
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  ROI Calculator Tool
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  L&D Glossary
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Upcoming Events
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Onboarding Templates
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h5 className="ah-text-md mb-15 mb-md-20 fw-bold">Our Customers</h5>
            <ul className="list-unstyled">
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Login to Your Account
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Knowledge Base
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Release Notes
                </Link>
              </li>
              <li className="mb-5 mb-sm-7 ah-text-sm fw-normal">
                <Link to={""} className="footer-links">
                  Engagement Academy
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom d-flex justify-content-between align-items-center flex-wrap pt-10 pt-sm-15 pt-md-23 pt-lg-30 gap-3">
          <ul className="nav gap-3 gap-lg-5">
            <li className="ah-text-sm fw-bold">
              <Link to={""} className="footer-links">
                Legal Notice
              </Link>
            </li>
            <li className="ah-text-sm fw-bold">
              <Link to={""} className="footer-links">
                Privacy Policy
              </Link>
            </li>
            <li className="ah-text-sm fw-bold">
              <Link to={""} className="footer-links">
                GDPR Notice
              </Link>
            </li>
            <li className="ah-text-sm fw-bold">
              <Link to={""} className="footer-links">
                Cookies
              </Link>
            </li>
            <li className="ah-text-sm fw-bold">
              &copy;EGWB. All rights reserved.
            </li>
          </ul>
          <ul className="nav gap-4 align-items-center">
            <li>
              <Link to={""}>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.69326 0.351562C1.59813 0.351562 0.709717 1.21292 0.709717 2.27409V25.2684C0.709717 26.3297 1.59823 27.1902 2.69326 27.1902H25.5649C26.6604 27.1902 27.5484 26.3295 27.5484 25.268V2.27409C27.5484 1.21292 26.6604 0.351562 25.5649 0.351562H2.69326ZM4.62892 23.1023H8.58503V10.3277H4.62892V23.1023ZM4.24869 6.29765C4.24869 7.59936 5.2961 8.65479 6.58813 8.65479C7.88008 8.65479 8.9275 7.59944 8.92741 6.29765C8.92741 4.99578 7.88 3.94043 6.58813 3.94043C5.29625 3.94043 4.24869 4.99578 4.24869 6.29765ZM19.4737 23.1023H23.4106V15.0136C23.4106 11.5921 21.4705 9.93806 18.7604 9.93806C16.0502 9.93806 14.9089 12.0483 14.9089 12.0483V10.3277H11.1145V23.1023H14.9089V16.3967C14.9089 14.6002 15.7362 13.5309 17.3197 13.5309C18.7747 13.5309 19.4737 14.5575 19.4737 16.3967V23.1023Z"
                    fill="#F05203"
                  />
                </svg>
              </Link>
            </li>
            <li>
              <Link to={""}>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.0968 13.8529C27.0968 6.39631 21.0888 0.351562 13.6774 0.351562C6.2661 0.351562 0.258057 6.39631 0.258057 13.8529C0.258057 20.5917 5.1653 26.1774 11.5806 27.1902V17.7557H8.17338V13.8529H11.5806V10.8784C11.5806 7.49462 13.5841 5.62552 16.6493 5.62552C18.117 5.62552 19.6532 5.88923 19.6532 5.88923V9.21183H17.9612C16.2942 9.21183 15.7742 10.2526 15.7742 11.3214V13.8529H19.496L18.9011 17.7557H15.7742V27.1902C22.1895 26.1774 27.0968 20.5917 27.0968 13.8529Z"
                    fill="#F05203"
                  />
                </svg>
              </Link>
            </li>
            <li>
              <Link to={""}>
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_362_1953)">
                    <path
                      d="M30.0841 9.65929C29.9323 9.08831 29.6332 8.56719 29.2169 8.1481C28.8004 7.72902 28.2812 7.42664 27.7113 7.27125C25.613 6.70703 17.2259 6.70703 17.2259 6.70703C17.2259 6.70703 8.83878 6.70703 6.74048 7.27125C6.17049 7.42664 5.65129 7.72902 5.23489 8.1481C4.81847 8.56719 4.51942 9.08831 4.3677 9.65929C3.80652 11.7667 3.80652 16.1616 3.80652 16.1616C3.80652 16.1616 3.80652 20.5564 4.3677 22.6639C4.51942 23.2349 4.81847 23.7559 5.23489 24.1751C5.65129 24.5941 6.17049 24.8965 6.74048 25.0519C8.83878 25.6162 17.2259 25.6162 17.2259 25.6162C17.2259 25.6162 25.613 25.6162 27.7113 25.0519C28.2812 24.8965 28.8004 24.5941 29.2169 24.1751C29.6332 23.7559 29.9323 23.2349 30.0841 22.6639C30.6452 20.5564 30.6452 16.1616 30.6452 16.1616C30.6452 16.1616 30.6452 11.7667 30.0841 9.65929Z"
                      fill="#F05203"
                    />
                    <path
                      d="M14.4803 20.1514L21.495 16.1607L14.4803 12.1699V20.1514Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_362_1953">
                      <rect
                        width="33.5484"
                        height="33.5484"
                        fill="white"
                        transform="translate(0.45166)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
